import React from "react";
import PropTypes from "prop-types";
import styles from "./ServerErrorMessage.css";
import { withTranslation } from "../translation";

export const ServerErrorMessage = ({
  status,
  formatLink,
  formatTranslation
}) => {
  const errorType =
    status === 404
      ? {
          header: "plp_web_errors_not_found_header",
          details: "plp_web_errors_not_found_details"
        }
      : {
          header: "plp_web_errors_server_side_error_header",
          details: "plp_web_errors_server_side_error_details"
        };

  return (
    <div className={styles.errorMessage}>
      <h1 className={styles.title}>{formatTranslation(errorType.header)}</h1>
      <p className={styles.message}>{formatTranslation(errorType.details)}</p>
      <a href={formatLink("")} className={styles.button}>
        {formatTranslation("plp_web_errors_homepage_button")}
      </a>
    </div>
  );
};

ServerErrorMessage.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired,
  status: PropTypes.number
};

ServerErrorMessage.displayName = "ServerErrorMessage";

export default withTranslation(ServerErrorMessage);
